import api from '../api-methods'

const proxyAuth = process.env.VUE_APP_ENV === 'local' ? '/proxy_auth' : process.env.VUE_APP_API_AUTH
const proxyApi = process.env.VUE_APP_ENV === 'local' ? '/proxy_api' : process.env.VUE_APP_API

const auth = {
	// 刷新jwt
	refreshJwt: payload => {
		return api.put(proxyAuth + '/v3/jwts', payload)
	},
	miniprogramAutoLogin: payload => {
		return api.post(proxyApi + '/v3/auth/wechat_unionid_users/login_or_sign_up', payload)
	},
	// 获取用户手机或邮箱验证码（新接口）
	getValidateCodeNew: payload => {
		return api.post(proxyAuth + '/v3/phone_codes', payload)
	},
	// 提交验证码绑定手机号
	updatePhone: (user_token, payload) => {
		return api.put(proxyAuth + `/v3/users/${user_token}`, payload)
	},
	/* 获取网申提醒二维码 */
  getRemindCode: payload => {
	return api.get(proxyAuth + '/v3/wechat_qr_codes', payload)
  },
	// 通过js code 登录
	signInWechat: payload => {
		return api.post(proxyApi + '/v3/auth/wechat_web_users/login_or_sign_up', payload)
	},
	// 获取用于关注公众号的二维码
	getQrCodeUrl: payload => {
  	return api.get(proxyAuth + '/v3/wechat_qr_codes', payload)
	},
	// 获取短信验证码接口V3
	getValidateCodeV3: payload => {
  	return api.post(proxyAuth + '/v3/phone_codes', payload)
	},
	// h5扫码登录
	scanQRCodeToLogin: payload => {
  	return api.post(proxyAuth + '/v3/scan_app_qr_codes', payload)
	},
	// 通过jwt，给用户创建cv_accounts身份
	create_cv_account: payload => {
  	return api.post(proxyApi + '/v3/auth/cv_accounts', payload)
	},
	// 通过jwt，给用户创建cv_accounts身份
	getUserBind: user_token => {
  	return api.get(proxyAuth + `/v3/users/${user_token}`, {})
	},
	// 手机号登录
	loginByPhone: payload => {
  	return api.post(proxyApi + `/v3/auth/phone_users/login_or_sign_up`, payload)
	},
	// 邀请新用户绑定关系
	setRelationship: payload => {
  	return api.put(proxyApi + `/v3/cv_accounts/invite_transfer`, payload)
	},
	// 获取被邀请用户列表信息
	getInviteList: payload => {
  	return api.get(proxyApi + `/v3/cv_accounts/invitee_infos`, payload)
	},
	// 邀请好友数量达到要求之后领取福利
	getMyInviteWelfare: payload => {
  	return api.post(proxyApi + `/v3/cv_accounts/invite_rewards`, payload)
	},
	// 绑定手机号时自动填充手机号
	getUserCvPhone: cv_account_token => {
  	return api.get(proxyApi + `/v3/cv_accounts/${cv_account_token}/cv_phone`)
	},
	// 检查当前手机号是不是新用户
	checkUser: params => {
		return api.put(proxyAuth + `/v3/users/check`, params)
	},


}

export default auth
